export enum ReplenishType {
  PICKER_REQUEST = 'picker_request',
  LOW_STOCK = 'low_stock',
  LOW_STOCK_COMMITTED = 'low_stock_committed',
}
